import Link from '@/components/Link/Link';
import tw, { styled } from 'twin.macro';
import { variants } from '@/components/Link/Link.styles';

export const ToggleContainer = styled.div`
  ${tw`inline-flex gap-[5px]`}
  ${tw`bg-neutrals-n1`}
  ${tw`border-2 border-secondary-s1`}
  ${tw`rounded-[80px]`}
  ${tw`p-[4px]`}
`;

export const ToggleButton = styled(Link)<{ isActive: boolean }>`
  ${variants.toggle}
`;
